export enum RouteData {
  BREADCRUMB = 'breadcrumb',
  BREADCRUMB_ICON = 'breadcrumbIcon',
  BACK_TO_PARENT_BUTTON = 'backToParentButton',
  DASHBOARD_VIEW_TYPE = 'dashboardViewType',
  ALL_PORTFOLIOS = 'allPortfolios',
  SOURCE_VIEW = 'sourceView',
  DASHBOARD_SOURCE = 'dashboardSource',
  DO_NOT_STORE_PARAMS = 'doNotStoreParams',
  PERIOD_DATE_SEARCH_FIELDS = 'periodDateSearchFields',
  PORTFOLIO_ID = 'portfolioId',
  COLLECTION_IDS = 'collectionIds',
  PROPERTY_IDS = 'propertyIds',
  PREV_PROPERTY_IDS = 'prevPropertyIds',
  BULK_SECTION_ID = 'bulkSectionId',
  STATUS = 'status',
  STEP_TYPE = 'stepType',
  UNIT_TYPE = 'unitType',
  TURN_ASSIGNEE_ID = 'turnAssigneeId',
  ASSIGNEE_ID = 'assigneeId',
  TICKET_ID = 'ticketId',
  COMMENT_ID = 'commentId',
  KANBAN_SECTION = 'kanban-section',
  TURNOVER_OVERVIEW_STATE = 'turnover-overview-state',
  WORKFLOW_STEP = 'workflow-step',
  INSPECTIONS_VIEW = 'inspectionsView',
  WORKFLOW_PHASE_TYPE = 'workflowPhaseType',
  LABEL = 'label',
}
